/* esm.sh - @radix-ui/react-dropdown-menu@2.1.16 */
export * from "/*@radix-ui/react-dropdown-menu@2.1.16/esnext/react-dropdown-menu.mjs";
